/**
 * The smallest unit of the Block & GameBoardGrid Objects.
 * 
 * @param {*} params 
 * @returns 
 */
import { useEffect, useState } from "react";
import './BlockUnit.css';
import { useGlobalState } from "../../GlobalState";

export function BlockUnit( { params } ){

    const { BASE_LENGTH_PX } = useGlobalState();

    /** @type {String} Color of the block. */
    const [ color, setColor ] = useState( params.color || 'transparent' );

    /** @type {Boolean} Is this block unit empty? */
    const [ isEmpty, setIsEmpty ] = useState( params?.isEmpty ?? false );

    /** @type {Boolean} Does this unit have a border? */
    const [ isOutline, setIsOutline ] = useState( params?.isOutline ?? false );

    /** @type {Boolean} Does this unit have a border? */
    const [ length, setLength ] = useState( BASE_LENGTH_PX * (params.lengthRatio ?? 1));

    return (
        <div style={{
            backgroundColor: color, 
            boxShadow: isOutline ? 'inset 0 0 0 5px black' : 'none',
            width: length+'px',
            height: length+'px',
            transition: "background-color 1.5s ease-in"
        }} className="BlockUnit"></div>
    );
}